import React from 'react';
import PropTypes from 'prop-types';

function BannerImage({ srcImage, onBannerClick, width, height }) {
  return (
    <div onClick={onBannerClick}>
      <span />
      <img 
        alt="Banner" 
        src={srcImage} 
        style={{ borderRadius: '8px', objectFit: 'cover' }} 
        width={width || '100%'} 
        height={height || 'auto'}
      />
    </div>
  );
}

BannerImage.propTypes = {
  srcImage: PropTypes.string,
  onBannerClick: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BannerImage;
